// Vendor imports
import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
export class ReportLinkComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.tooltipContent = '';
        this.url = '';
        this.name = '';
        this.tooltipContent = this.eltRef.nativeElement.getAttribute('tooltipContent');
        this.url = this.eltRef.nativeElement.getAttribute('url');
        this.name = this.eltRef.nativeElement.getAttribute('name');
    }
}
ReportLinkComponent.ɵfac = function ReportLinkComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReportLinkComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
ReportLinkComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportLinkComponent, selectors: [["ycn-report-link-component"]], standalone: false, decls: 2, vars: 4, consts: [["ycnTooltip", "", 3, "href", "tooltipPlacement", "tooltipTitle"]], template: function ReportLinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵpropertyInterpolate("href", ctx.url, i0.ɵɵsanitizeUrl);
        i0.ɵɵproperty("tooltipPlacement", "bottom")("tooltipTitle", ctx.tooltipContent);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.name);
    } }, dependencies: [i1.TooltipDirective], encapsulation: 2 });
